/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import { Typography } from '@tvg/fuse/typography';
import { FeatureBullet } from '../Shared/FeatureBullet';
import styles from './InsuranceDescription.module.css';

interface Props {
  description?: string;
  boldDescription?: string;
  dataTestId?: string;
  covered?: string[];
  notCovered?: string[];
  coverdTitle?: string;
  notCoveredTitle?: string;
  withDescription?: boolean;
}

export function InsuraceDescription({
  description,
  boldDescription,
  dataTestId = 'insurance-description',
  covered,
  notCovered,
  coverdTitle = 'What’s covered',
  notCoveredTitle = 'Not covered',
  withDescription = true,
}: Props) {
  return (
    <div data-testid={dataTestId}>
      {withDescription && (
        <Typography className={styles.description} size="m1" tag="p" type="paragraph">
          {`${description} `}
          <Typography size="m1" color="var(--color-global-black)" tag="span" type="heading">
            {boldDescription}
          </Typography>
        </Typography>
      )}
      <Typography
        className={styles.whatsCovered}
        color="var(--color-global-black)"
        size={notCovered ? 'm1' : '1'}
        tag="p"
        type="heading"
      >
        {coverdTitle}
      </Typography>
      {covered?.map((coveredItem: string, idx) => (
        <FeatureBullet key={`${coveredItem}-${idx}`} featureBullet={coveredItem} isCovered />
      ))}
      {notCovered ? (
        <>
          <Typography
            className={styles.whatsCovered}
            color="var(--color-global-black)"
            size={notCovered ? 'm1' : '1'}
            tag="p"
            type="heading"
          >
            {notCoveredTitle}
          </Typography>
          {notCovered.map((notCoveredItem: string, idx) => (
            <FeatureBullet key={`${notCoveredItem}-${idx}`} featureBullet={notCoveredItem} isCovered={false} />
          ))}
        </>
      ) : null}
    </div>
  );
}

export default InsuraceDescription;
